import { render, staticRenderFns } from "./PageOrderDetail.vue?vue&type=template&id=6619d1d4&"
import script from "./PageOrderDetail.vue?vue&type=script&lang=ts&"
export * from "./PageOrderDetail.vue?vue&type=script&lang=ts&"
import style0 from "./PageOrderDetail.vue?vue&type=style&index=0&id=6619d1d4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports